<template>
  <section class="upload-default">
    <header>
      <div class="flow-btn" v-if="!viewonly">
        <button v-show="dataLoaded" @click="previousStep">{{ $t('buttons.back') }}</button>
      </div>
      <div class="title">
        <h1>{{ $t('create.defaultTitleCountry') }} ({{ country }}):</h1>
        <p>{{ $t(`create.defaultSubtitle${country}`) }}</p>
      </div>
      <div class="flow-btn" v-if="!viewonly">
        <button v-show="dataLoaded" @click="saveAndUpload">{{ $t(isDirty ? 'buttons.saveUpload' : 'buttons.continue') }}</button>
      </div>
    </header>
    <transition name="fade">
      <div v-if="dataLoaded" class="screens" ref="screens">
        <div class="screen-title" v-if="country === 'Canada'">
          <div class="line" />
          <div class="title">Images (English)</div>
          <div class="line" />
        </div>
        <upload-screen
          :key="`en1-${country}`"
          v-model="isChecked1En"
          :files="screen1FilesEn"
          :list="screen1ListEn"
          :label="$t('media.screen') + ' 1 (' + $t('media.screensaver') + ')'"
          language="en"
          @updated="changed"
        />
        <upload-screen
          :key="`en2-${country}`"
          v-model="isChecked2En"
          :files="screen2FilesEn"
          :list="screen2ListEn"
          :label="$t('media.screen') + ' 2 (' + $t('media.presentPayment') + ')'"
          language="en"
          @updated="changed"
        />
        <upload-screen
          :key="`en3-${country}`"
          v-model="isChecked3En"
          :files="screen3FilesEn"
          :list="screen3ListEn"
          :label="$t('media.screen') + ' 3 (' + $t('media.payment') + ')'"
          language="en"
          @updated="changed"
        />
        <upload-screen
          :key="`en4-${country}`"
          v-model="isChecked4En"
          :files="screen4FilesEn"
          :list="screen4ListEn"
          :label="$t('media.screen') + ' 4 (' + $t('media.thankYou') + ')'"
          language="en"
          @updated="changed"
        />
        <template v-if="country === 'Canada'">
          <div class="screen-title" style="margin-top: 50px;">
            <div class="line" />
            <div class="title">Images (French)</div>
            <div class="line" />
          </div>
          <upload-screen
            :key="`fr1-${country}`"
            v-model="isChecked1Fr"
            :files="screen1FilesFr"
            :list="screen1ListFr"
            :label="$t('media.screen') + ' 1 (' + $t('media.screensaver') + ')'"
            language="fr"
            @updated="changed"
          />
          <upload-screen
            :key="`fr2-${country}`"
            v-model="isChecked2Fr"
            :files="screen2FilesFr"
            :list="screen2ListFr"
            :label="$t('media.screen') + ' 2 (' + $t('media.presentPayment') + ')'"
            language="fr"
            @updated="changed"
          />
          <upload-screen
            :key="`fr3-${country}`"
            v-model="isChecked3Fr"
            :files="screen3FilesFr"
            :list="screen3ListFr"
            :label="$t('media.screen') + ' 3 (' + $t('media.payment') + ')'"
            language="fr"
            @updated="changed"
          />
          <upload-screen
            :key="`fr4-${country}`"
            v-model="isChecked4Fr"
            :files="screen4FilesFr"
            :list="screen4ListFr"
            :label="$t('media.screen') + ' 4 (' + $t('media.thankYou') + ')'"
            language="fr"
            @updated="changed"
          />
        </template>
      </div>
    </transition>
    <footer v-if="!viewonly" v-show="dataLoaded">
      <button @click="previousStep">{{ $t('buttons.back') }}</button>
      <button @click="saveAndUpload">{{ $t(isDirty ? 'buttons.saveUpload' : 'buttons.continue') }}</button>
    </footer>
  </section>
</template>

<script>
import UploadScreen from '@/components/UploadScreen.vue'
import { GET_DEFAULT_MEDIA, SAVE_DEFAULT_MEDIA } from '@/store/actions.type'
import { LOAD_DEFAULT_MEDIA } from '@/store/mutations.type'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'upload-default-country',
  components: {
    UploadScreen
  },
  props: {
    viewonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isChecked1En: true,
      isChecked2En: true,
      isChecked3En: true,
      isChecked4En: true,
      isChecked1Fr: true,
      isChecked2Fr: true,
      isChecked3Fr: true,
      isChecked4Fr: true,
      isModalOpen: false,
      dataLoaded: false,
      isDirty: false
    }
  },
  computed: {
    ...mapState({
      screen1ListEn: state => state.media.screen1ListEn,
      screen2ListEn: state => state.media.screen2ListEn,
      screen3ListEn: state => state.media.screen3ListEn,
      screen4ListEn: state => state.media.screen4ListEn,
      screen1ListFr: state => state.media.screen1ListFr,
      screen2ListFr: state => state.media.screen2ListFr,
      screen3ListFr: state => state.media.screen3ListFr,
      screen4ListFr: state => state.media.screen4ListFr,
    }),
    ...mapGetters({
      screen1FilesEn: 'screen1En',
      screen2FilesEn: 'screen2En',
      screen3FilesEn: 'screen3En',
      screen4FilesEn: 'screen4En',
      screen1FilesFr: 'screen1Fr',
      screen2FilesFr: 'screen2Fr',
      screen3FilesFr: 'screen3Fr',
      screen4FilesFr: 'screen4Fr',
    }),
    country() {
      return this.$route.params.page === 'ca' ? 'Canada' : 'USA'
    },
  },
  methods: {
    changed() {
      this.isDirty = true;
    },
    previousStep() {
      this.$emit('back')
    },
    getDefaultMedia() {
      const loader = this.$loading.show({
        container: this.$refs.screens,
        opacity: 1,
        backgroundColor: 'transparent'
      })
      this.$store
        .dispatch(GET_DEFAULT_MEDIA)
        .then(() => {
          this.loadDefaultMedia()
          this.dataLoaded = true
          loader.hide()
        })
        .catch(err => {
          loader.hide()
          window.alert(err)
        })
    },
    loadDefaultMedia() {
      this.$store.commit(LOAD_DEFAULT_MEDIA, this.$route.params.page.toUpperCase())
    },
    saveAndUpload() {
      const loader = this.$loading.show()
      this.$store
        .dispatch(SAVE_DEFAULT_MEDIA, this.$route.params.page)
        .then(() => {
          loader.hide()
          this.$emit('next')
        })
        .catch(err => {
          loader.hide()
          window.alert(err)
        })
    },
    checkDirty(event) {
      if (this.isDirty) {
        event.returnValue = 'Are you sure you want to lose your unsaved changes?'
      }
    }
  },
  watch: {
    country() {
      this.dataLoaded = false
      this.loadDefaultMedia()
      this.$nextTick(() => {
        this.dataLoaded = true
      })
    }
  },
  mounted() {
    this.getDefaultMedia()
    window.addEventListener('beforeunload', this.checkDirty)
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.checkDirty)
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 300ms;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.screens {
  min-height: 150px;
  position: relative;

  .screen-title {
    display: flex;
    align-items: center;
    max-width: 975px;
    margin: 0 auto 20px auto;

    .title {
      font: 600 16px/21px Omnes;
      letter-spacing: 0.4px;
      color: #0B0F4D;
      opacity: 1;
      margin: 0 25px;
    }

    .line {
      flex-grow: 1;
      border: 1px solid #ADADAD;
    }
  }
}
.screen {
  margin: 0 auto 25px;
  padding: 50px;
  max-width: 875px;
}
footer {
  display: flex;
  justify-content: space-between;
}
</style>
